/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Items_Split_TitleInputs */

const vi_lot_items_split_title = /** @type {(inputs: Lot_Items_Split_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tách thành nhiều lô`)
};

/**

* @param {Lot_Items_Split_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_split_title = /** @type {((inputs?: Lot_Items_Split_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_Split_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_split_title(inputs)
});